<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner v-if="banner.length" :banner="banner[0]" />

    <!-- 面包屑 -->
    <div class="crumbs">
      <div>会员专区 > 注册/登陆</div>
    </div>

    <div class="container-width">
      <div class="form">
        <h3>注册</h3>
        <el-form ref="regForm" :model="regForm" :rules="regRules">
          <el-form-item prop="phone">
            <el-input v-model="regForm.phone" placeholder="手机号码" />
          </el-form-item>
          <el-form-item prop="smsCode">
            <el-input class="send-txt" v-model="regForm.smsCode" placeholder="验证码" />
            <div :class="['btn send-btn', {'btn-disable': !canClick}]" @click="sendCodeHandler">
              {{ sendCodeTxt }}
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="regForm.password" placeholder="输入密码" />
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input type="password" v-model="regForm.confirmPassword" placeholder="再次输入密码" />
          </el-form-item>
          <el-form-item prop="name">
            <el-input v-model="regForm.name" placeholder="输入姓名" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="regForm.idCard" placeholder="输入身份证号" />
          </el-form-item>
          <div class="btn primary" @click="regHandler" style="margin-top: 32px;">立即注册</div>
          <!-- <div class="btn" @click="$router.push('/login')">登陆</div> -->
          <div class="form-bottom">
            <span class="fr mouse" @click="$router.push('/login')">立即登陆</span>
          </div>
        </el-form>
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import { checkPhone } from '@/utils/util'
import { register, sendSms } from '@/service/apis/userinfo'
import { getBanner } from '@/service/apis/common'

export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'Register',
  data () {
    const isPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else if (!checkPhone(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validatePass2 =  (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.regForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      banner: [],
      regForm: {
        phone: '',
        smsCode: '', // 邀请码
        password: '',
        confirmPassword: '',
        name: '',
        idCard: ''
      },
      regRules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: isPhone, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        confirmPassword: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        idCard: [
          {required: true, message: '请输入身份证号', trigger: 'blur'}
        ]
      },
      sendCodeTxt: '发送验证码',
      totalTime: 60,
      canClick: true // 是否可点击
    }
  },
  created () {
    getBanner(this).then(data => {
      // 会员专区banner 11
      if (data[11]) {
        this.banner = [...data[11]]
      }
    })
  },
  methods: {
    // 注册
    regHandler () {
      this.$refs['regForm'].validate((valid) => {
        if (valid) {
          register.call(this, {
            ...this.regForm
          }).then(res => {
            if (res.errCode === 0) {
              this.$message({
                type: 'success',
                message: '注册成功',
                duration: 1500,
                onClose: () => {
                  this.$router.replace('/login')
                }
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 发送验证码请求
    sendCodeHandler () {
      if (!this.canClick) {
        return false
      }
      let _this = this
      this.$refs.regForm.validateField('phone', (valid) => {
        if (!valid) {
          sendSms.call(_this, {
            mobile: _this.regForm.phone
          }).then(res => {
            if (res.errCode === 0) {
              this.$message.success('发送验证码成功，请注意查收短信')

              this.canClick = false
              this.sendCodeTxt = this.totalTime + 's后重新发送'
              let clock = window.setInterval(() => {
                this.totalTime --
                this.sendCodeTxt = this.totalTime + 's后重新发送'
                if (this.totalTime < 0) {
                  window.clearInterval(clock)
                  this.sendCodeTxt = '重新发送验证码'
                  this.totalTime = 60
                  this.canClick = true  //这里重新开启
                }
              }, 1000)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.form {
  padding: 22px 0;
  max-width: 490px;
}
.form h3 {
  font-size: 18px;
  line-height: 44px;
}
.btn {
  color: #fff;
  margin-top: 14px;
  height: 38px;
  line-height: 38px;
  cursor: pointer;
  text-align: center;
  background-color: #846edc;
}
.btn.primary {
  background-color: #4c2ac9;
}
::v-deep .el-form-item {
  margin-bottom: 18px;
}
.send-txt {
  float: left;
  width: calc(100% - 32.6% - 8px);
}
.send-btn {
  margin-top: 0;
  float: right;
  display: block;
  width: 32.6%;
}
.btn-disable {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-bottom {
  color: #666;
  padding: 12px 0 48px 0;
  line-height: 22px;
}
.color1 {
  color: #4c2ac9;
}
.form-bottom span:hover {
  color: #4c2ac9;
}
</style>
